<div class="grid-container padding-y-5">
  <h2 class="margin-bottom-5">TMSS 2.0 Frequently Ask Questions</h2>
  <p class="text-bold padding-x-5">Q: Why am I getting "Unable to Sign In"?</p>
  <p class="padding-x-5 margin-bottom-5"><strong>A:</strong> You are entering the wrong password or you do not have a GSA FAS ID account. Reset your password or create a new account.</p>

  <p class="text-bold padding-x-5">Q: What if I forgot my password?</p>
  <p class="padding-x-5 margin-bottom-5"><strong>A:</strong> From the login screen, Click "Need Help Signing in?" and then "Forgot/Reset Password?"</p>

  <p class="text-bold padding-x-5">Q: Why am I not receiving the password reset email?</p>
  <p class="padding-x-5 margin-bottom-5"><strong>A:</strong> We do not have an account associated with the email address you entered.</p>

  <p class="text-bold padding-x-5">Q: What if I don't know my "Forgotten Password Challenge question?"</p>
  <p class="padding-x-5 margin-bottom-5"><strong>A:</strong> Contact the GSA Advantage Help Desk for assistance</p>

  <p class="text-bold padding-x-5">Q: Why aren't I receiving the one-time login verification code?</p>
  <p class="padding-x-5 margin-bottom-5"><strong>A:</strong> Make sure you are clicking the button to send the code.  Only request the code one-time.</p>

  <p class="text-bold padding-x-5">Q: How long is the one-time login verification code valid?</p>
  <p class="padding-x-5 margin-bottom-5"><strong>A:</strong> 30 minutes</p>

  <p class="text-bold padding-x-5">Q: I received a one-time login verification code, why isn't it working?</p>
  <p class="padding-x-5 margin-bottom-5"><strong>A:</strong> Request the code one-time and wait for it to arrive.  Requesting the code again, generates a new code and expires the previous code.</p>

  <p class="text-bold padding-x-5">Q: Why doesn't the "Do not challenge me on this device for the next 12 hours" box work after I check it?</p>
  <p class="padding-x-5 margin-bottom-5"><strong>A:</strong> This feature requires the use of stored cookies in your web browser. Check your browser cookie settings, or contact your organization's IT service desk for more assistance.</p>
  <div class="usa-alert usa-alert--info" >
    <div class="usa-alert__body">
      <h4 class="usa-alert__heading">If you require further assistance, contact us at <a href="mailto:gsatmsshelp@gsa.gov">gsatmsshelp&#64;gsa.gov</a></h4>
    </div>
  </div>
</div>
